<div class="modal__wrapper" *ngIf="isOpened">
  <div [ngClass]="['modal', modalClass ?? '']">

      <ng-content></ng-content>

  </div>
</div>
